import { useState, useEffect, useCallback, useRef, memo } from "react"
//import { useRequest } from "./../hooks"
import { STEPS, TRANSIT_DELAY, KILL_ROUTE, LAUNCH_ROUTE, UPDATE_ROUTE, LAUNCH_DURATION } from "./../constants"
import { KILL_DURATION } from "./../styles"
import { SWAP_DURATION, UPDATE_DURATION } from "./../WatchRoller/styles"
import { logmine, focusCta } from "./../utils"
import { useWatchVariations, mvSubscribe } from "./../context"
import { useResults } from "./../catalog"

export const Route = ({ ctx }) => {
  const { family, entry, steps, stepindex, newstepindex, active, newactive, collection, getModel, route, reset, variations, catready, incard } = useWatchVariations(ctx)
  const tm = useRef(null)

  function kill() {
    route.set(null)
    //    steps.set(null)
    //    stepindex.set(-1)
    //    active.set(entry.get())
  }

  function init() {
    const item = getModel(entry.get())
    if (!item) return
    const step = findNextStep(item)
    const next = !!item.next ? item.next[0] : 0
    const newroute = ["", item.uid, !!step ? step : STEPS[next]].join("/")
    reset.set(newroute)
  }

  function update() {
    clearTimeout(tm.current)
    const _route = route.get()
    const _entry = entry.get()
    if (!_route) {
      steps.set(`0,0,${_entry}`)
      newstepindex.set(0)
      stepindex.set(0)
      return
    }
    if (!reset.get()) init()
    if (!catready.get()) return
    if (_route === KILL_ROUTE) {
      newstepindex.set(0)
      tm.current = setTimeout(kill, KILL_DURATION)
      return
    }
    const _reset = reset.get()
    if (_route === LAUNCH_ROUTE) {
      tm.current = setTimeout(() => route.set(_reset), LAUNCH_DURATION / 2)
      return
    }
    if (_route === UPDATE_ROUTE) {
      //      newstepindex.set(0)
      //      steps.set(null)
      //      tm.current = setTimeout(() => {
      route.set(KILL_ROUTE)
      active.set(entry.get())
      //      }, UPDATE_DURATION)
      return
    }
    let [RMC, _STEP] = _route.split("/").slice(1)
    let uid = RMC || _entry
    let wmodel = getModel(uid)
    if (!wmodel || !_STEP) {
      tm.current = setTimeout(() => route.set(_reset), 10)
      return
    }
    let _stepindex = STEPS.indexOf(_STEP)
    if (_stepindex < 0) {
      tm.current = setTimeout(() => route.set(_reset), 10)
      return
    }
    newactive.set(wmodel.uid)
    newstepindex.set(_stepindex)
    tm.current = setTimeout(swap, !_route ? 0 : TRANSIT_DELAY)

    function swap() {
      stepindex.set(_stepindex)
      active.set(wmodel.uid)
      let vars = wmodel.vars[_STEP]
      if (_STEP === "model") vars = wmodel.vars["size"] || vars
      if (!vars) return
      let items = !route.get() ? [wmodel.uid] : vars.split(",")
      const index = items.indexOf(wmodel.uid)
      if (index < 0) throw new Error(`"${wmodel.uid}" model unfindable in "${_STEP}" variations`)
      const _steps = [_stepindex, index, !route.get() ? wmodel.uid : vars].join(",")
      steps.set(_steps)
    }
  }

  function findNextStep(wmodel) {
    let step = null
    variations.map(v => {
      if (!step && !!wmodel.vars[v]) step = v
    })
    return step?.replace("size", "model")
  }

  useResults(route, family, collection, catready, incard)

  useEffect(() => mvSubscribe("Route", catready, update, false), [])
  useEffect(() => mvSubscribe("Route", route, update), [])

  return null
}
